import axios from "axios";
import { toast } from "react-toastify";
import { combinedUrls } from "../../../../../URL/functions";
import { projectUrls } from "../../../../../URL/ApplicationUrls";

export async function duplicateRoute(
  projectId: number | undefined,
  routeId: number,
  routeNumber: string
) {
  async function fetchDuplicateRoute() {
    const request = { routeNumber: routeNumber.toUpperCase() };

    const url = combinedUrls(
      projectUrls.projectWithId(projectId).apiUrl,
      `/Duplicate/${routeId}`
    );
    const response = await axios.post(url, request);
    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }
  }

  await toast.promise(fetchDuplicateRoute(), {
    pending: "Pending",
    error: {
      render({ data }: { data: any }) {
        return data?.message;
      },
    },
    success: `Route ${routeNumber} has been duplicated`,
  });
}
